<template>
  <div class="page-container">
    <div class="page-header">
      <h2>报告管理</h2>
      <el-button type="primary" @click="openEdit()">新建报告</el-button>
    </div>
    <div class="search-bar">
      <el-input v-model="key" placeholder="报告编号/标题" clearable @keyup.enter.native="load"></el-input>
      <el-select v-model="bgzt" placeholder="状态" clearable @change="load">
        <el-option label="草稿" value="draft"></el-option>
        <el-option label="待审核" value="pending"></el-option>
        <el-option label="已签发" value="issued"></el-option>
      </el-select>
      <el-button type="default" @click="load">查询</el-button>
    </div>
    <el-table :data="list" v-loading="loading" stripe border size="small">
      <el-table-column prop="bgbh" label="报告编号" width="180"></el-table-column>
      <el-table-column prop="bgbt" label="报告标题" min-width="200"></el-table-column>
      <el-table-column prop="xmmc" label="项目名称" width="160"></el-table-column>
      <el-table-column prop="wtdw_mc" label="委托单位" width="150"></el-table-column>
      <el-table-column prop="bzr_xm" label="编制人" width="90"></el-table-column>
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{row}">
          <el-tag :type="ztTag(row.bgzt)" size="small">{{ ztLabel(row.bgzt) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="qfrq" label="签发日期" width="120"></el-table-column>
      <el-table-column label="操作" width="220" fixed="right">
        <template slot-scope="{row}">
          <el-button type="text" size="small" @click="exportPdf(row)" :loading="exportingId===row.id">导出</el-button>
          <el-button type="text" size="small" @click="openEdit(row)">编辑</el-button>
          <el-button type="text" size="small" @click="issue(row)" v-if="row.bgzt==='pending'">签发</el-button>
          <el-button type="text" size="small" style="color:#f56c6c" @click="del(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="editForm.id?'编辑报告':'新建报告'" :visible.sync="showEdit" width="600px">
      <el-form :model="editForm" label-width="100px" size="small">
        <el-form-item label="关联项目">
          <el-select v-model="editForm.xmid" filterable placeholder="请选择项目" style="width:100%" @change="onProjectChange">
            <el-option v-for="p in projects" :key="p.id" :label="(p.xmbh||'')+' '+p.xmmc" :value="p.id">
              <span>{{ p.xmbh }}</span>
              <span style="color:#8492a6;font-size:12px;margin-left:8px">{{ p.xmmc }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="报告编号">
              <el-input v-model="editForm.bgbh" placeholder="自动生成" :disabled="!editForm.id"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="报告标题"><el-input v-model="editForm.bgbt"></el-input></el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="委托单位"><el-input v-model="editForm.wtdw_mc" :disabled="true" placeholder="从项目自动获取"></el-input></el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="编制人">
              <el-select v-model="editForm.bzr_id" filterable placeholder="请选择" style="width:100%" clearable @change="onBzrChange">
                <el-option v-for="u in users" :key="u.id" :label="u.xm" :value="u.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-select v-model="editForm.bgzt" style="width:100%">
                <el-option label="草稿" value="draft"></el-option>
                <el-option label="待审核" value="pending"></el-option>
                <el-option label="已签发" value="issued"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit=false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </el-dialog>

    <!-- 导出完整性检查 -->
    <el-dialog title="导出前完整性检查" :visible.sync="checkDialogVisible" width="560px">
      <el-table :data="exportChecklist" size="small" border stripe>
        <el-table-column prop="label" label="检查项" min-width="180" />
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="row.tagType" size="mini">{{ row.statusText }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="detail" label="说明" min-width="200" show-overflow-tooltip />
      </el-table>
      <el-alert
        v-if="exportBlocked"
        type="error"
        :closable="false"
        show-icon
        style="margin-top:12px"
        title="存在关键项缺失，无法导出"
      />
      <div slot="footer">
        <el-button @click="checkDialogVisible=false">取消</el-button>
        <el-button
          type="primary"
          :disabled="exportBlocked"
          @click="proceedExport"
        >{{ exportBlocked ? '无法导出' : (exportHasWarn ? '仍要导出' : '确认导出') }}</el-button>
      </div>
    </el-dialog>

    <!-- 导出进度弹窗 -->
    <el-dialog title="正在导出报告" :visible.sync="exportDialogVisible" width="420px" :close-on-click-modal="false" :show-close="!exporting">
      <div class="export-progress-box">
        <div class="export-progress-title">{{ exportFileName || '正在生成并下载报告...' }}</div>
        <el-progress :percentage="exportProgress" :status="exportProgress===100 ? 'success' : undefined" />
        <div class="export-progress-tip">{{ exportProgress < 100 ? '请稍候，不要关闭页面' : '导出完成' }}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/utils/api'
import { getCurrentUser } from '@/utils/user'

const API_BASE = (process.env.VUE_APP_API_BASE || '') + '/yn_api.php'

export default {
  data() {
    return {
      list: [],
      loading: false,
      key: '',
      bgzt: '',
      showEdit: false,
      editForm: {},
      projects: [],
      users: [],
      exporting: false,
      exportingId: null,
      checkDialogVisible: false,
      exportChecklist: [],
      exportBlocked: false,
      exportHasWarn: false,
      pendingExportRow: null,
      exportDialogVisible: false,
      exportProgress: 0,
      exportFileName: ''
    }
  },
  mounted() {
    this.load()
    this.loadProjects()
    this.loadUsers()
  },
  methods: {
    async load() {
      this.loading = true
      const params = {}
      if (this.key) params.key = this.key
      if (this.bgzt) params.bgzt = this.bgzt
      const res = await api.get('yn_bg_list', params)
      this.list = res.data || []
      this.loading = false
    },
    async loadProjects() {
      const res = await api.get('yn_xm_list', { zt: '' })
      this.projects = res.data || []
    },
    async loadUsers() {
      const res = await api.get('yn_yh_list', {})
      this.users = res.data || []
    },
    openEdit(row) {
      if (row) {
        this.editForm = { ...row }
      } else {
        // 自动生成报告编号
        const today = new Date()
        const dateStr = today.getFullYear().toString() +
          (today.getMonth() + 1).toString().padStart(2, '0') +
          today.getDate().toString().padStart(2, '0')
        const seq = String(this.list.length + 1).padStart(3, '0')
        this.editForm = {
          xmid: '',
          xmbh: '',
          xmmc: '',
          wtdw_mc: '',
          bgbh: 'BG-' + dateStr + '-' + seq,
          bgbt: '检测报告',
          bzr_id: '',
          bzr_xm: '',
          shrid: '',
          shr_xm: '',
          pzrid: '',
          pzr_xm: '',
          bgzt: 'draft'
        }
      }
      this.showEdit = true
    },
    onProjectChange(xmid) {
      const p = this.projects.find(x => x.id === xmid)
      if (p) {
        this.editForm.xmbh = p.xmbh || ''
        this.editForm.xmmc = p.xmmc || ''
        this.editForm.wtdw_mc = p.wtdw_mc || ''
        // 自动设置编制人为项目负责人
        if (p.xmfzr_id && !this.editForm.bzr_id) {
          this.editForm.bzr_id = p.xmfzr_id
          this.editForm.bzr_xm = p.xmfzr_xm || ''
        }
      }
    },
    onBzrChange(yhid) {
      const u = this.users.find(x => x.id === yhid)
      if (u) {
        this.editForm.bzr_xm = u.xm || ''
      }
    },
    async save() {
      if (!this.editForm.xmid) {
        this.$message.warning('请选择关联项目')
        return
      }
      await api.post('yn_bg_save', this.editForm)
      this.showEdit = false
      this.$message.success('保存成功')
      this.load()
    },
    async issue(row) {
      await this.$confirm('确认签发该报告？', '提示')
      await api.get('yn_bg_zt', { id: row.id, bgzt: 'issued' })
      this.$message.success('已签发')
      this.load()
    },
    async del(row) {
      await this.$confirm('确认删除？', '提示')
      await api.get('yn_bg_del', { id: row.id })
      this.$message.success('已删除')
      this.load()
    },
    async exportPdf(row) {
      if (!row || !row.id || this.exporting) return
      if (!row.xmid) {
        this.$message.warning('该报告未关联项目，无法导出')
        return
      }
      const check = await this.buildExportChecklist(row)
      this.exportChecklist = check.items
      this.exportBlocked = check.blocked
      this.exportHasWarn = check.hasWarn
      this.pendingExportRow = row
      this.checkDialogVisible = true
    },
    async buildExportChecklist(row) {
      const items = []
      let blocked = false
      let hasWarn = false
      const xmbh = row.xmbh || ''
      const add = (label, ok, detail, critical) => {
        const statusText = ok ? '完成' : (critical ? '缺失' : '待完善')
        const tagType = ok ? 'success' : (critical ? 'danger' : 'warning')
        items.push({ label, ok, detail, critical, statusText, tagType })
        if (!ok && critical) blocked = true
        if (!ok && !critical) hasWarn = true
      }

      if (!xmbh) {
        add('项目编号', false, '报告未关联项目编号', true)
        return { items, blocked, hasWarn }
      }

      let phase = {}
      let labProg = null
      let has056 = false
      let has093 = false
      try {
        const [pr, lp, ho] = await Promise.all([
          api.get('yn_tr_project_phase', { xmbh }),
          api.get('yn_tr_lab_progress', { xmbh }),
          api.get('yn_tr_handover_form', { xmbh })
        ])
        phase = pr.data || {}
        labProg = lp.data && !lp.data.error ? lp.data : null
        const hoData = (ho.data && ho.data.data) || {}
        has056 = !!(hoData.jyr || hoData.jjy || hoData.jysj || hoData.jjsj || hoData.jyr_xm || hoData.jjy_xm)
      } catch (e) { /* ignore */ }

      add('135 派遣单', !!phase.has135, phase.has135 ? '已保存' : '请先填写135派遣单', true)

      const sc = phase.sample_count || 0
      const fd = phase.field_done_count || 0
      const ok054 = sc === 0 || fd >= sc
      add('054 现场采样', ok054, sc ? `已完成 ${fd}/${sc} 个样品` : '无样品记录', true)

      add('056 样品交接', has056, has056 ? '交接信息已录入' : '056 交接可能未完成', false)

      if (phase.soil_physics) {
        try {
          const f93 = await api.get('yn_tr_field_form', { xmbh, num: '093' })
          const d93 = (f93.data && f93.data.data) || {}
          has093 = Object.keys(d93).some(k => String(d93[k] || '').trim() !== '')
        } catch (e) { /* ignore */ }
        add('093 土壤理化性', has093, has093 ? '已填写' : '项目勾选理化性但093未填', false)
      }

      if (labProg) {
        const okLab = labProg.percent >= 100
        add('理化检测表', okLab, `${labProg.done || 0}/${labProg.total || 0}（${labProg.percent || 0}%）`, false)
      } else {
        add('理化检测表', false, '无法读取进度', false)
      }

      return { items, blocked, hasWarn }
    },
    async proceedExport() {
      if (this.exportBlocked || !this.pendingExportRow) return
      this.checkDialogVisible = false
      await this.doExportPdf(this.pendingExportRow)
      this.pendingExportRow = null
    },
    async doExportPdf(row) {
      let formCount = 0
      try {
        const u = getCurrentUser()
        const sync = await api.get('yn_tr_form_sync', { xmid: row.xmid, xmbh: row.xmbh || '', yhid: u.id || '' })
        if (sync.data && sync.data.count) formCount = sync.data.count
        else {
          const fr = await api.get('yn_bdsl_list', { xmid: row.xmid })
          formCount = (fr.data || []).filter(r => r.mbid != -135 || r.sj_json).length
        }
      } catch (e) { /* ignore */ }

      this.exporting = true
      this.exportingId = row.id
      this.exportDialogVisible = true
      this.exportProgress = 5
      this.exportFileName = (row.bgbh || row.bgbt || '报告') + '.pdf'
      if (formCount > 0) {
        this.$message.info(`正在导出：报告正文 + ${formCount} 份项目表单（请翻到 PDF 中后段查看）`)
      } else {
        this.$message.warning('该项目下暂无已填表单，导出仅含报告正文')
      }

      try {
        const url = API_BASE + '?yn_bg_export=1&id=' + row.id
        const res = await fetch(url)

        if (!res.ok) throw new Error('下载失败: HTTP ' + res.status)

        const contentType = (res.headers.get('Content-Type') || '').toLowerCase()
        if (contentType.includes('text/plain')) {
          const text = await res.text()
          throw new Error(text || '导出失败')
        }

        const disposition = res.headers.get('Content-Disposition') || ''
        let filename = this.exportFileName
        const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i)
        const plainMatch = disposition.match(/filename="?([^";]+)"?/i)
        if (utf8Match) filename = decodeURIComponent(utf8Match[1])
        else if (plainMatch) filename = decodeURIComponent(plainMatch[1])

        const total = Number(res.headers.get('Content-Length') || 0)
        if (res.body && res.body.getReader) {
          const reader = res.body.getReader()
          const chunks = []
          let received = 0
          while (true) {
            const { done, value } = await reader.read()
            if (done) break
            chunks.push(value)
            received += value.length
            if (total) this.exportProgress = Math.min(99, Math.round((received / total) * 100))
          }
          const blob = new Blob(chunks)
          this.downloadBlob(blob, filename)
        } else {
          const blob = await res.blob()
          this.downloadBlob(blob, filename)
        }

        this.exportProgress = 100
        this.$message.success('导出完成')
      } catch (e) {
        this.exportDialogVisible = false
        this.$message.error(e.message || '导出失败')
      } finally {
        this.exporting = false
        this.exportingId = null
      }
    },
    downloadBlob(blob, filename) {
      const blobUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = blobUrl
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(blobUrl)
    },
    ztTag(v) { return { draft: 'info', pending: 'warning', issued: 'success' }[v] || 'info' },
    ztLabel(v) { return { draft: '草稿', pending: '待审核', issued: '已签发' }[v] || v }
  }
}
</script>

<style scoped>
.export-progress-box {
  text-align: center;
  padding: 20px;
}
.export-progress-title {
  font-size: 16px;
  margin-bottom: 16px;
}
.export-progress-tip {
  color: #909399;
  margin-top: 12px;
}
</style>